
<div>
    <section class="tab mb-4">
        <nav>
            <a v-for="(terminal, index) in terminals"
                href="#"
                :class="{'active': activeTerminal == terminal.slug}"
                :key="index"
                @click.prevent="setTerminal(terminal.slug)">

                {{terminal.title}}
            </a>
        </nav>

        <div class="tab-container terminals-map" v-if="activeTerminal">
            <div class="tab-container-map my-4" id="tab-container-map"> 
                <img v-if="image" :src="image" :data-zoom-src="imageFullSize" class='term-img-fluid' alt='asur' width="800" height="600" data-zoomable @click.prevent="toggleZoom"/>
            </div>

            <!--<div class="domNode" style="z-index: 9999;">
                <div id="domNode" style="z-index: 9999;"></div>
            </div>-->
            
            <div class="tab-container-list">
                <label>{{floor || 'Planta baja'}}</label>

                <ul class="col3">
                    <a v-for="(store, index) in stores[page]"
                        class="capitalize secret-class"
                        :href="`/${locale}/${locale == 'es' ? 'tiendas' : 'stores'}/${store.slug}`"
                        :key="index">
                        {{store.location ? store.location < 10 ? `0${store.location}` : store.location : '--'}}: 
                        {{store.title ? store.title.toLowerCase() : ''}}
                    </a>
                </ul>

                <Pagination
                    position="align-items-center justify-content-center"
                    :pages="pages"
                    v-model="page"
                    :total="total"
                    :customMessage="customMessage"/>
            </div>  
        </div>
    </section>
</div>
